module.exports = __webpack_public_path__ + "media/images/goals-segment-4fc4fc53da6712aaa1096bbe82e3670d.jpg";